// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    width: '100%',
    marginTop: 92,
  },
  commentsContainer: {
    width: '100%',
    marginTop: 60,
    [theme.breakpoints.down(1800)]: {
      marginTop: 40,
    },
    [theme.breakpoints.down(1600)]: {
      marginTop: 30,
    },
    [theme.breakpoints.down(1368)]: {
      marginTop: 20,
    },
  },
  commentInnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
  },
  titleText: {
    textAlign: 'center',
    fontSize: GlobalStyles.fonts.FONT_SIZE_EXTRA_MAX,
    fontFamily: GlobalStyles.fonts.FONT_MONTSERRAT_BOLD,
    [theme.breakpoints.down(1800)]: {
      fontSize: 42,
    },
    [theme.breakpoints.down(1600)]: {
      fontSize: 32,
    },
    [theme.breakpoints.down(1368)]: {
      fontSize: 28,
    },
    [theme.breakpoints.down(500)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE
    },
  },
  descriptionText: {
    textAlign: 'center',
    fontSize: GlobalStyles.fonts.FONT_SIZE_MAX,
    fontFamily: GlobalStyles.fonts.FONT_MONTSERRAT_MEDIUM,
    [theme.breakpoints.down(1600)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
    },
    [theme.breakpoints.down(1368)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    },
    [theme.breakpoints.down(500)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE
    },
  },
});

export default styles;
